import { AboutPageData } from '..';

export const AboutFallbackData: AboutPageData = {
  id: 1,
  documentId: 'caqjd58bc0v67xy6grkr9k83',
  createdAt: '2025-08-18T18:14:43.830Z',
  updatedAt: '2025-08-18T18:14:43.841Z',
  publishedAt: null,
  locale: null,
  seo: {
    id: 2,
    metaTitle: 'Về Chúng Tôi - Công Ty TNHH Cơ Khí Chính Xác Bách Việt',
    metaDescription:
      'Tìm hiểu về công ty TNHH Cơ Khí Chính Xác Bách Việt - đơn vị chuyên gia công cơ khí chính xác tại Hà Nội với đội ngũ kỹ thuật viên lành nghề và kinh nghiệm lâu năm.',
    keywords:
      'cơ khí, gia công, Bách Việt, Hà Nội, linh kiện, phụ tùng, máy móc',
    metaImage: null,
  },
  hero: {
    id: 1,
    title: 'VỀ CHÚNG TÔI',
    content: null,
    backgroundImage: {
      id: 32,
      documentId: 'ge9b3b75zbs78o3d9opssijx',
      name: 'about-us-image.jpg',
      alternativeText: 'An image uploaded to Strapi called about-us-image.jpg',
      caption: 'An image uploaded to Strapi called about-us-image.jpg',
      width: 4096,
      height: 2732,
      formats: {
        thumbnail: {
          name: 'thumbnail_about-us-image.jpg',
          hash: 'thumbnail_about_us_image_jpg_e074c1d729',
          ext: '.jpeg',
          mime: 'image/jpeg',
          path: null,
          width: 234,
          height: 156,
          size: 11.79,
          sizeInBytes: 11790,
          url: '/uploads/thumbnail_about_us_image_jpg_e074c1d729.jpeg',
        },
        small: {
          name: 'small_about-us-image.jpg',
          hash: 'small_about_us_image_jpg_e074c1d729',
          ext: '.jpeg',
          mime: 'image/jpeg',
          path: null,
          width: 500,
          height: 333,
          size: 37.15,
          sizeInBytes: 37148,
          url: '/uploads/small_about_us_image_jpg_e074c1d729.jpeg',
        },
        medium: {
          name: 'medium_about-us-image.jpg',
          hash: 'medium_about_us_image_jpg_e074c1d729',
          ext: '.jpeg',
          mime: 'image/jpeg',
          path: null,
          width: 750,
          height: 500,
          size: 67.85,
          sizeInBytes: 67849,
          url: '/uploads/medium_about_us_image_jpg_e074c1d729.jpeg',
        },
        large: {
          name: 'large_about-us-image.jpg',
          hash: 'large_about_us_image_jpg_e074c1d729',
          ext: '.jpeg',
          mime: 'image/jpeg',
          path: null,
          width: 1000,
          height: 667,
          size: 106.6,
          sizeInBytes: 106596,
          url: '/uploads/large_about_us_image_jpg_e074c1d729.jpeg',
        },
      },
      hash: 'about_us_image_jpg_e074c1d729',
      ext: '.jpeg',
      mime: 'image/jpeg',
      size: 1538.41,
      url: '/uploads/about_us_image_jpg_e074c1d729.jpeg',
      previewUrl: null,
      provider: 'local',
      provider_metadata: null,
      folderPath: '/',
      createdAt: '2025-08-18T18:14:43.789Z',
      updatedAt: '2025-08-18T18:14:43.789Z',
      publishedAt: '2025-08-18T18:14:43.789Z',
      locale: null,
    },
  },
  coreValues: {
    id: 1,
    title: 'GIÁ TRỊ CỐT LÕI',
    backgroundImage: null,
    values: [
      {
        id: 1,
        title: 'Chất lượng',
        description:
          'Hoạt động minh bạch, hiệu quả, tiếp tục tiệm cận với những tiêu chuẩn cao của quản trị kinh doanh quốc tế. Tạo ra những sản phẩm và dịch vụ với chất xám cao, đáp ứng tối đa nhu cầu của tầng lớp khách hàng.',
        icon: {
          id: 33,
          documentId: 'wgc1mepjn4ny3fgsnuo5uo40',
          name: 'core-value-icon.svg',
          alternativeText:
            'An image uploaded to Strapi called core-value-icon.svg',
          caption: 'An image uploaded to Strapi called core-value-icon.svg',
          width: 55,
          height: 48,
          formats: null,
          hash: 'core_value_icon_6e684058e7',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 9,
          url: '/uploads/core_value_icon_6e684058e7.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:43.807Z',
          updatedAt: '2025-08-18T18:14:43.807Z',
          publishedAt: '2025-08-18T18:14:43.808Z',
          locale: null,
        },
      },
      {
        id: 2,
        title: 'Sáng tạo',
        description:
          'Luôn đổi mới và sáng tạo trong mọi hoạt động, áp dụng công nghệ tiên tiến để mang đến giải pháp tối ưu cho khách hàng.',
        icon: {
          id: 34,
          documentId: 'lvslkstlao7vqwde19z648sh',
          name: 'core-value-icon.svg',
          alternativeText:
            'An image uploaded to Strapi called core-value-icon.svg',
          caption: 'An image uploaded to Strapi called core-value-icon.svg',
          width: 55,
          height: 48,
          formats: null,
          hash: 'core_value_icon_0088e93bf7',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 9,
          url: '/uploads/core_value_icon_0088e93bf7.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:43.817Z',
          updatedAt: '2025-08-18T18:14:43.817Z',
          publishedAt: '2025-08-18T18:14:43.817Z',
          locale: null,
        },
      },
      {
        id: 3,
        title: 'Tận tâm',
        description:
          'Đặt lợi ích của khách hàng lên hàng đầu, cam kết cung cấp dịch vụ chất lượng cao với sự tận tâm và trách nhiệm.',
        icon: {
          id: 35,
          documentId: 'mbnpcb4tr0c3c44b609q54nq',
          name: 'core-value-icon.svg',
          alternativeText:
            'An image uploaded to Strapi called core-value-icon.svg',
          caption: 'An image uploaded to Strapi called core-value-icon.svg',
          width: 55,
          height: 48,
          formats: null,
          hash: 'core_value_icon_036674ea75',
          ext: '.svg',
          mime: 'image/svg+xml',
          size: 9,
          url: '/uploads/core_value_icon_036674ea75.svg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          folderPath: '/',
          createdAt: '2025-08-18T18:14:43.824Z',
          updatedAt: '2025-08-18T18:14:43.824Z',
          publishedAt: '2025-08-18T18:14:43.824Z',
          locale: null,
        },
      },
    ],
  },
  featuredProjects: {
    id: 2,
    title: 'DỰ ÁN TIÊU BIỂU',
    subtitle: 'Những dự án nổi bật mà chúng tôi đã thực hiện thành công',
    projects: [],
  },
  partners: {
    id: 2,
    title: 'ĐỐI TÁC',
    subtitle: null,
    autoPlay: false,
    autoPlayInterval: 5000,
    partners: [],
  },
  cta: {
    id: 2,
    title: 'Liên hệ để hợp tác',
    description:
      'Chúng tôi luôn sẵn sàng hỗ trợ bạn trong việc bắt đầu dự án mới hoặc cung cấp thông tin.',
    buttonText: 'LIÊN HỆ NGAY',
    buttonLink: '/contact',
    backgroundImage: null,
  },
};
